/** Pole danych uczestnika, którego dotyczy wiersz rachunku. */
export enum ParticipantBillField {
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  BIRTH_DATE = 'BIRTH_DATE',
}
